module.exports = __webpack_public_path__ + "img/SampleReport.427f19ee.png";